import { getAssetCategories } from 'utils/helper/assetType';

export const filters = ({ allowableCategories }) => {
  return {
    RegularFilters: [
      {
        label: 'Archived',
        field: 'archived',
        type: 'toggle',
      },
      {
        label: 'Handover Required',
        field: 'handoverRequired',
        type: 'toggle',
      },
      {
        label: 'Qualification Required',
        field: 'qualificationRequired',
        type: 'toggle',
      },
      {
        label: 'Category',
        field: 'category',
        type: 'select',
        options: getAssetCategories(allowableCategories),
      },
    ],
  };
};
